"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.texVariant = void 0;
var FontData_js_1 = require("../../FontData.js");
var tex_variant_js_1 = require("../../../common/fonts/tex/tex-variant.js");
exports.texVariant = (0, FontData_js_1.AddCSS)(tex_variant_js_1.texVariant, {
    0x3F0: { c: '\\E009' },
    0x210F: { f: '' },
    0x2224: { c: '\\E006' },
    0x2226: { c: '\\E007' },
    0x2268: { c: '\\E00C' },
    0x2269: { c: '\\E00D' },
    0x2270: { c: '\\E011' },
    0x2271: { c: '\\E00E' },
    0x2288: { c: '\\E016' },
    0x2289: { c: '\\E018' },
    0x228A: { c: '\\E01A' },
    0x228B: { c: '\\E01B' },
    0x2A87: { c: '\\E010' },
    0x2A88: { c: '\\E00F' },
    0x2ACB: { c: '\\E017' },
    0x2ACC: { c: '\\E019' },
});
//# sourceMappingURL=tex-variant.js.map